"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLocationService = exports.LocationItemToEnum = exports.LocationKeyModeEnum = void 0;
var app_1 = require("app");
var lists_1 = require("../../lists");
var LocationKeyModeEnum;
(function (LocationKeyModeEnum) {
    LocationKeyModeEnum[LocationKeyModeEnum["Code"] = 0] = "Code";
    LocationKeyModeEnum[LocationKeyModeEnum["Title"] = 1] = "Title";
    LocationKeyModeEnum[LocationKeyModeEnum["EnglishTitle"] = 2] = "EnglishTitle";
})(LocationKeyModeEnum = exports.LocationKeyModeEnum || (exports.LocationKeyModeEnum = {}));
var LocationItemToEnum;
(function (LocationItemToEnum) {
    LocationItemToEnum[LocationItemToEnum["FilterAutoCompleteItem"] = 0] = "FilterAutoCompleteItem";
    LocationItemToEnum[LocationItemToEnum["SelectOptionItem"] = 1] = "SelectOptionItem";
})(LocationItemToEnum = exports.LocationItemToEnum || (exports.LocationItemToEnum = {}));
var BaseLocationService = /** @class */ (function () {
    function BaseLocationService(config) {
        var _this = this;
        this.config = config;
        this.parseCountryCode = function (countyCode) {
            var result = '';
            if (countyCode) {
                result = countyCode.indexOf(':') !== -1 ? countyCode.split(':')[1] : countyCode;
            }
            return result;
        };
        this.filterOutInvalidTranslation = function (translations) {
            return translations.filter(function (translation) {
                var isNotFulfilled = !translation.code || !translation.translation;
                if (isNotFulfilled) {
                    // tslint:disable-next-line:no-console
                    console.warn("[" + _this.serviceName + "]: Not all data is set for item: " + JSON.stringify(translation));
                }
                return !isNotFulfilled;
            });
        };
        this.mapItemsToUIModel = function (items, translations, mapItemTo, prefix) {
            if (!items) {
                return null;
            }
            return items.map(function (item) {
                var translation = _this.getTranslationForItem(translations, item);
                return _this.mapToUIItem(item, translation, prefix, mapItemTo);
            });
        };
        this.createAutoCompleteItem = function (info, translation) {
            return {
                internalKey: info.code,
                key: _this.getKeyByMode(info, translation),
                value: translation,
            };
        };
        this.createSelectOptionItem = function (info, translation) {
            return {
                title: translation,
                value: _this.getKeyByMode(info, translation),
            };
        };
        this.addPrefix = function (item, prefix) {
            if (item) {
                var filterItem = item;
                filterItem.key = prefix + ":" + filterItem.key;
                filterItem.internalKey = prefix + ":" + filterItem.internalKey;
            }
        };
        this.getKeyByMode = function (locationInfo, translation) {
            switch (_this.config.keyMode) {
                case LocationKeyModeEnum.Code:
                    return locationInfo.code;
                case LocationKeyModeEnum.Title:
                    return translation;
                case LocationKeyModeEnum.EnglishTitle:
                    return locationInfo.name;
                default:
                    return locationInfo.code;
            }
        };
    }
    Object.defineProperty(BaseLocationService.prototype, "languageCode", {
        get: function () {
            var languageCode = app_1.UtilService.parseLanguageCode(this.config.culture);
            if (app_1.UtilService.parseCountryCode(this.config.culture).toLowerCase() === 'tw') {
                return languageCode + "-HANT";
            }
            return languageCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLocationService.prototype, "serviceName", {
        get: function () {
            return 'BaseLocationService';
        },
        enumerable: false,
        configurable: true
    });
    BaseLocationService.prototype.createLocaleStorageKey = function (prefix) {
        // tslint:disable-next-line:max-line-length
        return prefix + "_" + this.config.culture + "_" + (this.config.prefixNeeded ? 'prefix' : 'noprefix') + "_keymode-" + this.config.keyMode;
    };
    BaseLocationService.prototype.createDefaultStorageKey = function (prefix) {
        return prefix + "_default";
    };
    BaseLocationService.prototype.getTranslationForItem = function (translations, item) {
        var matchedTranslation = translations
            .filter(function (translateInfo) { return translateInfo.code === item.code; })
            .map(function (translateInfo) { return translateInfo.translation; })
            .filter(function (translation) { return !!translation; });
        return lists_1.getFirstOrDefault(matchedTranslation, item.name || item.code);
    };
    BaseLocationService.prototype.mapToUIItem = function (info, translation, prefix, mapItemTo) {
        if (mapItemTo === void 0) { mapItemTo = LocationItemToEnum.FilterAutoCompleteItem; }
        if (mapItemTo === LocationItemToEnum.FilterAutoCompleteItem) {
            return this.mapToFilterAutoCompleteItem(info, translation, prefix);
        }
        return this.mapToSelectOptionItem(info, translation, prefix);
    };
    BaseLocationService.prototype.mapToFilterAutoCompleteItem = function (info, translation, prefix) {
        var result = this.createAutoCompleteItem(info, translation);
        if (this.config.prefixNeeded) {
            this.addPrefix(result, prefix);
        }
        return result;
    };
    BaseLocationService.prototype.mapToSelectOptionItem = function (info, translation, prefix) {
        var result = this.createSelectOptionItem(info, translation);
        if (this.config.prefixNeeded) {
            this.addPrefix(result, prefix);
        }
        return result;
    };
    return BaseLocationService;
}());
exports.BaseLocationService = BaseLocationService;
